import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';

import { AppComponent } from './app.component';
import { SessionLayoutComponent } from './layout/session-layout/session-layout.component';
import { SharedModule } from './shared/shared.module';
import { httpInterceptorProviders } from './interceptors/interceptors';
import { SessionModule } from './session/session.module';
import { DashboardLayoutModule } from './layout/dashboard-layout.module';
import { DatePipe } from '@angular/common';
import { provideHttpClient, withJsonpSupport } from '@angular/common/http';

@NgModule({
  declarations: [AppComponent, SessionLayoutComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    DashboardLayoutModule,
    SessionModule,
    SharedModule,
  ],
  providers: [
    httpInterceptorProviders,
    DatePipe,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => inject(Sentry.TraceService as any)),
    provideHttpClient(withJsonpSupport()),
  ],
})
export class AppModule {}
